// @ts-nocheck
import { Route, Routes, Navigate } from 'react-router-dom';
import DashboardPage from './DashboardPage';

export default function DashboardRoutes() {
  return (
    <Routes>
      <Route index element={<DashboardPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
